<template>
	<div>
		<CModal title="Consultez le détail des colis" size="lg" :show.sync="showModal">
			<template v-if="showModal">
				<GDataTableRemote
					ref="mainTable"
					:remote-url="queryUrl"
					:fields="fields"
					:items-per-page="10"
					hover
					striped
					sorter
					columnFilter
					pagination />
			</template>

			<template #footer>
				<CButton color="secondary" v-on:click="showModal = false">Fermer</CButton>
			</template>
		</CModal>
	</div>
</template>

<script>
	import GDataTableRemote from '../../../../components/ghostlexly-components/GDataTableRemote';
	export default {
		components: {
			GDataTableRemote,
		},
		data() {
			return {
				queryUrl: '/api/cart_products',
				fields: [
					{ key: 'name', label: 'Nom' },
					{ key: 'id', label: 'Identifiant unique' },
					{ key: 'shippingNumber', label: 'Numéro de colis' },
				],
				showModal: false,
			};
		},
	};
</script>
